import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { REACT_APP_API_URL } from "../../../env";


export const fetchAllFootfall = createAsyncThunk(
  "footfall/fetchAllFootfall",
  async () => {
    try {
        const response = await axios.get(`${REACT_APP_API_URL}api/dashboard/admin/allfootfall`);     
        return response.data.data;  
      } catch (error) {
        throw new Error(error.response?.data?.message || error.message);  
      }
   
  }
);

export const addFootfall = createAsyncThunk(
  "footfall/addFootfall", 
  async (formData) => {
  try {
    const response = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/footfalladd`,formData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || error.message);
  }
 
});

export const updateFootfall = createAsyncThunk(
  "footfall/updateFootfall",
  async (formData) => {
    try {
      const response = await axios.put(`${REACT_APP_API_URL}api/dashboard/admin/footfallupdate/${formData.id}`, formData);
      console.log("Update response:", response.data);
      return response.data;
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const deleteFootfall = createAsyncThunk(
  "footfall/deleteFootfall",
  async (id) => {
    try {
      const response = await axios.delete(`${REACT_APP_API_URL}api/dashboard/admin/footfalldelete/${id}`);
      return response.data; 
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);

export const fetchFootfallReport = createAsyncThunk(
  "footfall/fetchFootfallReport",
  async ({ month, year, district }) => {
    try {
      const response = await axios.post(`${REACT_APP_API_URL}api/dashboard/admin/footfallreport`, {
        month,
        year,
        district
      });
      return response.data.data;  
    } catch (error) {
      throw new Error(error.response?.data?.message || error.message);
    }
  }
);


const footfallSlice = createSlice({
  name: "footfall",
  initialState: {
    footfallData: [],
    reportData: [],
    status: "idle",
    error: null,
    selectedDistrict: "",
  },
  reducers: {
    setSelectedDistrict: (state, action) => {
      state.selectedDistrict = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllFootfall.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchAllFootfall.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.footfallData  = action.payload;
        state.error = null; 
      })
      .addCase(fetchAllFootfall.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message; 
      })
      .addCase(addFootfall.fulfilled, (state, action) => {
        state.footfallData.push(action.payload); 
      })
      .addCase(updateFootfall.fulfilled, (state, action) => {
        const index = state.footfallData.findIndex(dest => dest.id === action.payload.id);
        if (index !== -1) {
          state.footfallData[index] = action.payload; 
        }
      })
      .addCase(deleteFootfall.fulfilled, (state, action) => {
        state.footfallData = state.footfallData.filter(dest => dest.id !== action.payload.id);
      })
      .addCase(fetchFootfallReport.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetchFootfallReport.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.reportData = action.payload; 
      })
      .addCase(fetchFootfallReport.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
      
  },
});
export const { setSelectedDistrict } = footfallSlice.actions;
export default footfallSlice.reducer;
